import { Component } from '@angular/core';

@Component({
  selector: 'ds-rg-address',
  templateUrl: './rg-address.component.html',
  styleUrl: './rg-address.component.scss'
})
export class RgAddressComponent {
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
}
